import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { TextInput } from '@telialt/common-text-input/src';
import { useUserData } from '@telialt/utils/src/SSO/useUserData';

import { LEAD_TEST_IDS } from '../constants';
import { LeadFieldName } from '../model';

type Props = { initialValue?: string };

export const NameSurnameField: FC<Props> = ({ initialValue }) => {
    const { t } = useTranslations();
    const { userData } = useUserData();

    return (
        <TextInput
            label={t['content.lead.name.label']}
            defaultValue={initialValue || userData?.fullName || ''}
            name={'nameSurname' as LeadFieldName}
            dataTest={LEAD_TEST_IDS.FIELD_NAME}
        />
    );
};
